interface SegmentedOption<T extends string> {
  value: T;
  label: string;
}

interface SegmentedProps<T extends string> {
  /** Wofuer die Gruppe steht -- fuer vorlesende Programme. */
  ariaLabel: string;
  options: readonly SegmentedOption<T>[];
  value: T;
  onChange: (value: T) => void;
}

/**
 * Umschaltung zwischen zwei bis fuenf Moeglichkeiten, von denen genau eine
 * gilt -- die Dichte einer Liste, der Zeitraum einer Auswertung.
 *
 * Als Gruppe gefasst statt als Reihe einzelner Schaltflaechen: So ist auf
 * einen Blick zu sehen, dass die Auswahl zusammengehoert und dass genau eine
 * davon gilt. ``aria-pressed`` sagt dasselbe dem vorlesenden Programm --
 * die Hervorhebung allein traegt die Aussage nicht.
 */
export function Segmented<T extends string>({
  ariaLabel,
  options,
  value,
  onChange,
}: SegmentedProps<T>) {
  return (
    <div className="segmented" role="group" aria-label={ariaLabel}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className="segmented__option"
          aria-pressed={option.value === value}
          onClick={() => {
            onChange(option.value);
          }}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
